export const ChevronLeftIcon: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      {...props}
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75045 14C8.06806 14 8.38567 13.8855 8.63642 13.6401C9.12119 13.1656 9.12119 12.3804 8.63642 11.9059L3.62149 6.99795L8.63642 2.08998C9.12119 1.61554 9.12119 0.830266 8.63642 0.355828C8.15164 -0.118609 7.34925 -0.118609 6.86448 0.355828L0.963582 6.13088C0.478806 6.60532 0.478806 7.39059 0.963582 7.86503L6.86448 13.6401C7.11522 13.8855 7.43284 14 7.75045 14Z"
        fill="currentColor"
      />
    </svg>
  );
};
